module.exports = __webpack_public_path__ + "563fdd457cdbeb0ca9c1185f9aed042f.pdf";